module.exports = "<?xml version=\"1.0\" ?><svg height=\"32\" id=\"check\" viewBox=\"0 0 32 32\" width=\"32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1 14 L5 10 L13 18 L27 4 L31 8 L13 26 z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/check2.svg
// module id = 558
// module chunks = 0